import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { appAxiosInstance } from './getAxiosInstance.ts'
import type { AxiosRequestConfig, AxiosError, AxiosInstance } from 'axios'

const createAxiosBaseQueryInstance = (instance: AxiosInstance) => {

    const axiosBaseQuery =
        (
            { baseUrl }: { baseUrl: string } = { baseUrl: '' }
        ): BaseQueryFn<
            {
                url: string
                method: AxiosRequestConfig['method']
                data?: AxiosRequestConfig['data']
                params?: AxiosRequestConfig['params']
                headers?: AxiosRequestConfig['headers']
            },
            unknown,
            unknown
        > =>
            async ({ url, method, data, params, headers }) => {

                // console.log("AXIOS REQUEST STARTED");
                // console.log("FULL URL:", baseUrl + url);
                // console.log("METHOD:", method);
                // console.log("PARAMS:", params);
                // console.log("DATA:", data);

                try {

                    const result = await instance({
                        url: baseUrl + url,
                        method,
                        data,
                        params,
                        headers,
                    })

                    // console.log("AXIOS SUCCESS");
                    // console.log("RESPONSE:", result.data);

                    return { data: result.data }

                } catch (axiosError) {

                    const err = axiosError as AxiosError

                    // console.log("AXIOS FAILED");
                    // console.log("ERROR:", err);
                    // console.log("STATUS:", err.response?.status);
                    // console.log("ERROR DATA:", err.response?.data);

                    return {
                        error: {
                            status: err.response?.status,
                            data: err.response?.data || err.message,
                        },
                    }
                }
            }

    return axiosBaseQuery;
}

export const appAxiosBaseQuery =
    createAxiosBaseQueryInstance(appAxiosInstance);